/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".badge.toAdd[_ngcontent-%COMP%]{background-color:rgba(92,211,92,.54)}.badge[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin:-12px;right:-5px;top:-1px}mat-radio-button[_ngcontent-%COMP%]{margin-right:1em}"];
export { styles as styles };
